import React, {Component} from 'react';
import {connect} from 'react-redux';
import {InputText} from '../../components';
import {reenviarAssinatura, updateDadosPessoais} from '../../ducks/Customer';
import {
  redirectToUpdateYourData,
  redirectToValidationAccessCode,
} from '../../ducks/Navigate';
import {ValidationService, StringService} from '../../services';
import validation from './validate';
import {RouteKeys} from '../../constants';

import './styles.scss';

class SignatureNotFound extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.SignatureNotFound.title,
    );
  }

  regexNumber = () => {
    var regexStr = this.props.celular.replace(/[^0-9]/g, '');
    return (
      '(' +
      regexStr.substring(0, 2) +
      ') ' +
      regexStr.substring(2, 7) +
      '-' +
      regexStr.substring(7)
    );
  };

  questionHandle = (event) => {
    event.preventDefault();
    this.props.redirectToUpdateYourData();
  };

  reenviarHandle = () => {
    if (!this.formIsValid()) return;
    this.props.reenviarAssinatura(this.props);
  };

  handleChange = (prop, value) => {
    this.props.updateDadosPessoais({prop, value});
  };

  formIsValid = () => ValidationService.validate(this.props, validation);

  render() {
    return (
      <div className="div-signature-not-found">
        <div className="header">
          <p>Não identificamos a assinatura do seu contrato</p>
          <div className="header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.66 32.66">
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <g id="alert-ok1">
                    <path
                      className="cls-1"
                      d="M16.33,32.66A16.33,16.33,0,1,1,32.66,16.33,16.35,16.35,0,0,1,16.33,32.66Z"
                    />
                  </g>
                  <path
                    className="cls-2"
                    d="M16.32,7.22c.85,0,2,.16,2,1.09a8.39,8.39,0,0,1-.1,1.14c-.24,1.84-.94,6.29-1.31,9.61H15.72c-.33-3.15-1-7.58-1.29-9.55a9.07,9.07,0,0,1-.15-1.21C14.28,7.44,15.43,7.22,16.32,7.22Zm0,18.22a1.94,1.94,0,0,1-2-2.07,2,2,0,0,1,2-2.06,2.07,2.07,0,0,1,0,4.13Z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div className="content">
          <p>Fique tranquilo. </p>
          <p>Confirme seus dados.</p>
          <p>Edite se necessário e clique em reenviar.</p>
          <br />
          <br />
          <InputText
            id="email"
            name="email"
            type="email"
            placeholder="E-mail"
            value={this.props.email}
            onChange={(ev) => this.handleChange('email', ev.target.value)}
          />
          <InputText
            id="celular"
            type="tel"
            name="celular"
            placeholder="DDD + Número do Celular"
            mask="(99) 99999-9999"
            value={this.props.celular}
            onChange={(ev) => this.handleChange('celular', ev.target.value)}
          />
        </div>
        <div className="button-container-flex">
          <div className="button-container" onClick={this.reenviarHandle}>
            <button className="button">Reenviar</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {chave, dadosPessoais} = customer;
  return {chave, ...dadosPessoais};
};

export default connect(mapStateToProps, {
  reenviarAssinatura,
  redirectToUpdateYourData,
  redirectToValidationAccessCode,
  updateDadosPessoais,
})(SignatureNotFound);
